import React from "react";

const Java_Int = () => {
  return (
    <div>
      <h1>Java Int</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Int in Java.</p>
    </div>
  );
};

export default Java_Int;
